module.exports = __webpack_public_path__ + "static/media/x-button.46fc597b.svg";